import axios from "axios";
import {store} from "../reducers";

const baseURL = process.env.REACT_APP_PREFERENCES_URL;

const Axios = axios.create({
    baseURL,
});

const getBasicHeaders = () => {
  const {DataCompany} = store.getState().auth;
  return {
    'user-token': DataCompany.Token,
    'moduleid': process.env.REACT_APP_MODULE_ID,
    'x-api-key': process.env.REACT_APP_PREFERENCES_API_KEY,
    'env': process.env.REACT_APP_ENV,
    'Content-Type': 'application/json',
  };
}

export const  getUserPreferences = async () => {
  const headers = await getBasicHeaders();
  const responde = await Axios.get('user-preferences', {headers});
  console.log('--- responde', responde)
  if (responde?.data?.success && responde?.data?.data) {
    return responde?.data;
  }
  return {}
}


export const  saveUserPreferences = async (preferences) => {
  const headers = await getBasicHeaders();
  const responde = await Axios.post('user-preferences', preferences, {headers});
  console.log('--- responde', responde)
  if (responde?.data?.success && responde?.data?.data) {
    return responde?.data;
  }
  return {}
}
